/**
 * Entry point — mounts the React subtitles app into #kft-subtitles-root.
 * Reads config from window.kftSubtitlesConfig (set by PHP).
 */

import { createRoot } from 'react-dom/client';
import Subtitles from './components/Subtitles';
import ErrorBoundary from './components/ErrorBoundary';

const root = document.getElementById('kft-subtitles-root');

if (root && window.kftSubtitlesConfig) {
  createRoot(root).render(
    <ErrorBoundary>
      <Subtitles config={window.kftSubtitlesConfig} />
    </ErrorBoundary>
  );
}
